import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_PATHS } from 'config.js';

const StaffNavLogo = () => {
  return (
    <div className="logo position-relative">
      <Link to={DEFAULT_PATHS.STAFF}>
        <div className="logo-nav" />
      </Link>
    </div>
  );
};
export default React.memo(StaffNavLogo);
